import SlotsInactivePage from '../Pages/SlotsInactivePage';

const SlotsInactiveRoutes = () => {
  return (
    <SlotsInactivePage />
  );
};

export default SlotsInactiveRoutes; 